import { sendRequestAuth } from 'api/api'
import { convertDateTimeToApiFormat } from 'common/form/datePicker/_functions'
import config from 'config'
import { useReducer } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  invoiceActions,
  invoiceReducer,
} from '../provider/_reducer'

import {
  invoiceInitialState,
} from '../provider/_initState'

const useInvoice = () => {
  const [searchParams] = useSearchParams()
  const nav = useNavigate()
  const [state, dispatch] = useReducer(invoiceReducer, invoiceInitialState)
  const { filter, table } = state

  const filterQueries = {
    date_type: filter.dateTime?.activeValue?.type?.value || '',
    start_date:
      filter.dateTime.activeValue?.start && filter.dateTime.activeValue.value
        ? convertDateTimeToApiFormat(
        filter.dateTime.activeValue.value.split(' - ')[0],
        )
        : '',
    end_date:
      filter.dateTime.activeValue?.end && filter.dateTime.activeValue.value
        ? convertDateTimeToApiFormat(
        filter.dateTime.activeValue.value.split(' - ')[1],
        )
        : '',
    payment_status: filter.status.activeValue?.value || '',
    month_time: filter.monthTime.activeValue || '',
    payment_method: filter.invoiceType.activeValue?.value || '',
    principal_id: filter.principal.activeValue?.value?.value || '',
    user_id: filter.teacher.activeValue?.value?.value || '',
    tracking_code: filter.invoiceInfo.activeValue || '',
  }

  const fetchRowDetail = async data => {
    if (!!!data?.id) {
      dispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })
      return
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/commission/tracking/detail/${data?.id}`,
    )

    if (!!response?.data?.success) {
      const newItem = response?.data?.data
      dispatch({
        type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
        payload: { active: newItem, list: [newItem] },
      })
    }

    dispatch({
      type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  const handleOriginFetch = async () => {

    const querySearch = searchParams.get('search') || ''
    if (querySearch)
      dispatch({
        type: invoiceActions.FILTER_ACTIVE_DATE_TIME_UPDATE,
        payload: {
          end: '',
          start: '',
          type: filter.dateTime.type,
          value: '',
        },
      })
    const response = await sendRequestAuth(
      'get',
      `${config.API}/commission/tracking/trackings?tracking_code=&principal_id=&user_id=&month_time=&payment_method=&payment_status=&start_date=&end_date=&start=0&per_page=20`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []
      // set default value for input filter
      dispatch({
        type: invoiceActions.FILTER_SEARCH_UPDATE,
        payload: { value: querySearch },
      })
      // update display list
      dispatch({
        type: invoiceActions.TABLE_AMOUNT_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: {
            totalItems: response?.data?.meta?.total || 0,
            active: 0,
            amount: 20,
            total: response?.data?.meta?.total
              ? Math.ceil(
                response?.data?.meta?.total / 20,
              )
              : 0,
          },
        },
      })
      // auto fetch detail invoice id and open
      if (querySearch) {
        dispatch({
          type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
          payload: { active: displayListData[0] },
        })
        fetchRowDetail({ id: querySearch })
      }
    }

    if (!querySearch) {
      dispatch({
        type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
        payload: { table: { display: { loading: false } } },
      })
    }
  }

  const handleCreateFormOriginFetch = async () => {
    const response = await Promise.all([
      sendRequestAuth(
        'get',
        `${
          config.API
        }/commission/filter/teachers?keyword=`,
      ),
    ])
    if (!!response[0]?.data) {
      dispatch({
        type: invoiceActions.CREATE_INVOICE_LIST_PRINCIPAL_UPDATE,
        payload: response[0]?.data
      })
    }

  }

  const handleDetailFetch = async (invoiceId) => {
    const response = await sendRequestAuth(
      'get',
      `${config.API}/invoice/detail/${invoiceId}`,
    )

    if (!!response?.data?.success) {
      // set default value for input filter
      const invoiceDetail = response.data.data
      if(!['new','processing'].includes(invoiceDetail.invoice_status)) nav('/invoice/digital')
      dispatch({
        type: invoiceActions.UPDATE_ORIGIN_DATA_FORM_EDIT,
        payload: {
          invoice: invoiceDetail,
          invoiceName: {
            value: invoiceDetail?.invoice_name,
            status: true,
            message: ''
          },
          invoicePhone: {
            value: invoiceDetail?.invoice_phone,
            status: true,
            message: ''
          },
          invoiceEmail: {
            value: invoiceDetail?.invoice_email,
            status: true,
            message: ''
          },
          invoiceAddress: {
            value: invoiceDetail?.invoice_address,
            status: true,
            message: ''
          },
          invoiceNotes: {
            value: invoiceDetail?.invoice_notes,
            status: true,
            message: ''
          },
          feeShip: {
            value: invoiceDetail?.shipping_fee,
            status: true,
            message: ''
          },
          details: invoiceDetail?.details,
        },
      })
    }
  }


  const handleFetchDetailHistory = async (historyId) => {
    const response = await sendRequestAuth(
      'get',
      `${config.API}/invoice/log/detail/${historyId}`,
    )

    if (!!response?.data?.success) {}
  }

  const handlePaginationAmountChange = async n => {
    dispatch({
      type: invoiceActions.TABLE_SELECTED_LIST_UPDATE,
      payload: { selected: { list: [] } },
    })
    dispatch({
      type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: true } } },
    })

    const currentPage = table.pagination.active || 0
    const totalPages = Math.ceil(table.pagination.totalItems / n)
    const page =
      table.pagination.totalItems < currentPage * n
        ? totalPages - 1
        : currentPage

    let queryStr = '?'
    let i = 0
    for (const [key, value] of Object.entries({
      ...filterQueries,
      type: 1,
      per_page: n,
      start: page * n,
    })) {
      queryStr += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/invoice/invoices${queryStr}`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []
      dispatch({
        type: invoiceActions.TABLE_AMOUNT_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: { active: page, amount: n, totalItems: response?.data?.meta?.total || 0,total: totalPages },
        },
      })

    }

    dispatch({
      type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
      payload: { active: null },
    })

    dispatch({
      type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  const handlePaginationPageChange = async page => {
    dispatch({
      type: invoiceActions.TABLE_SELECTED_LIST_UPDATE,
      payload: { selected: { list: [] } },
    })
    dispatch({
      type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: true } } },
    })

    const amount = table.pagination?.amount || 20

    let queryStr = '?'
    let i = 0
    for (const [key, value] of Object.entries({
      ...filterQueries,
      type: 1,
      per_page: amount,
      start: page * amount,
    })) {
      queryStr += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await sendRequestAuth(
      'get',
      `${config.API}/invoice/invoices${queryStr}`,
    )

    if (!!response?.data?.success) {
      const displayListData = Array.isArray(response?.data?.data)
        ? response.data.data
        : []

      dispatch({
        type: invoiceActions.TABLE_PAGINATION_UPDATE,
        payload: {
          display: {
            list: displayListData,
          },
          pagination: { active: page },
        },
      })
    }

    dispatch({
      type: invoiceActions.TABLE_DISPLAY_DETAIL_UPDATE,
      payload: { active: null },
    })

    dispatch({
      type: invoiceActions.TABLE_DISPLAY_LOADING_UPDATE,
      payload: { table: { display: { loading: false } } },
    })
  }

  return {
    fetch: {
      origin: handleOriginFetch,
      createOrigin: handleCreateFormOriginFetch,
      detail: handleDetailFetch,
      history: handleFetchDetailHistory,
    },
    pagination: {
      onAmountChange: handlePaginationAmountChange,
      onPageChange: handlePaginationPageChange,
    },
    provider: { state, dispatch },
  }
}

export default useInvoice
